export default __webpack_public_path__ + "static/media/check-green.4b870e99.gif";